// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"143":"app","736":"vendor","760":"delivery-mgmt"}[chunkId] + "." + {"143":"3376174d328a1a7456f6","736":"38aaaedfc074cd67f764","760":"175dad00d90a83cfe999"}[chunkId] + ".css";
};